
import Vue from "vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import { Group, Question } from "../models/Question";
import FormationQuiz from "../components/FormationQuiz.vue";
import Modal from "../components/shared/Modal.vue";
import { IUser } from "../@types/interface.d";
import UserAPI from "../api/UserAPI";
import shuffle from "../utils/shuffle";

dayjs.extend(utc);

//  2 | 律月ひかる
//  3 | 北美梨寧
//  4 | 葉月結菜
//  5 | 安杜羽加
//  6 | 吉瀬真珠
//  7 | 橘花怜
//  8 | 桜ひなの
//  9 | 藤谷美海
// 10 | 伊達花彩

const QUESTIONS = [
  new Question("天下一品〜みちのく革命〜", "完全燃焼どんな時も貫いていくよ", [
    new Group("ペア", [7, 10]),
    new Group("ペア", [2, 6]),
    new Group("ペア", [5, 8]),
    new Group("ペア", [3, 9]),
    new Group("ソロ", [4]),
  ]),
  new Question("うぢらとおめだづ", "バーチャルデートじゃ絶対できないキスをしよう", [
    new Group("ペア", [9, 10]),
    new Group("ペア", [2, 3]),
    new Group("ペア", [4, 5]),
    new Group("ペア", [6, 8]),
    new Group("ソロ", [7]),
  ]),
  new Question("Action", "いつもここから夢を見ている みんながひとつなることを", [
    new Group("ペア", [2, 4]),
    new Group("ペア", [6, 8]),
    new Group("ペア", [3, 5]),
    new Group("ペア", [9, 10]),
    new Group("ソロ", [7]),
  ]),
  new Question("Whatever", "きっと、憧れの自分に戻ることはないから", [
    new Group("ペア", [2, 6]),
    new Group("ペア", [3, 9]),
    new Group("ペア", [5, 8]),
    new Group("ペア", [4, 7]),
    new Group("ソロ", [10]),
  ]),
  /*
  new Question("テキーナ", "「愛してるよ」的な(テキーナ！)", [
    new Group("ペア", [3, 4]),
    new Group("ペア", [5, 7]),
    new Group("ペア", [2, 10]),
    new Group("ソロ", [6]),
    new Group("ソロ", [8]),
    new Group("ソロ", [9]),
  ]),
  */
  new Question("No Make", "Oh Well めいっぱい泣いて語り合って すぐに2人元通りさ", [
    new Group("ペア", [6, 10]),
    new Group("ペア", [5, 7]),
    new Group("ペア", [4, 9]),
    new Group("ペア", [3, 8]),
    new Group("ソロ", [2]),
  ]),
  new Question("BUBBLE POPPIN", "夢見た事の全て叶えられそうな気がしちゃってる", [
    new Group("ペア", [2, 8]),
    new Group("ペア", [3, 6]),
    new Group("ペア", [4, 7]),
    new Group("ペア", [5, 9]),
    new Group("ソロ", [10]),
  ]),
  new Question("桜プロミス", "好きだと伝えたときに 君から告げられた台詞", [
    new Group("ペア", [3, 8]),
    new Group("ペア", [5, 6]),
    new Group("ペア", [2, 10]),
    new Group("ペア", [4, 9]),
    new Group("ソロ", [7]),
  ]),
  new Question("恋はじめ", "すれ違うたびに目をそらしちゃうあなたに", [
    new Group("ペア", [3, 7]),
    new Group("ペア", [4, 5]),
    new Group("ペア", [2, 9]),
    new Group("ペア", [6, 10]),
    new Group("ソロ", [8]),
  ]),
];

interface DataType {
  questions: Question[];
  currentIndex: number;
  currentScore: number;
  user: IUser | undefined;
  descModal: boolean;
}

interface MethodType {
  init: () => void;
  verifyUser: () => Promise<IUser>;
  createUser: () => Promise<IUser>;
  start: () => void;
  prev: () => void;
  next: () => void;
  openDesc: () => void;
  closeDesc: () => void;
}

interface ComputedType {}

export default Vue.extend({
  name: "quiz",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
    FormationQuiz,
    Modal,
  },
  data(): DataType {
    return {
      questions: shuffle(QUESTIONS),
      currentIndex: -1,
      currentScore: 0,
      lastScore: 0,
      user: undefined,
      descModal: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("userToken");
      const user = await (userId && token
        ? UserAPI.verify(userId, token).catch(() => UserAPI.create())
        : UserAPI.create());
      this.user = user;
      localStorage.setItem("userId", user.id);
      localStorage.setItem("userToken", user.token);
      if (user.quizScore.length > 0) {
        this.currentScore = user.quizScore[user.quizScore.length - 1];
      }
    },
    start() {
      this.currentIndex = 0;
    },
    prev() {
      if (this.currentIndex === 0) {
        return;
      }
      this.currentIndex--;
    },
    next() {
      const user = this.user;
      if (!user) {
        return;
      }
      if (this.currentIndex === this.questions.length - 1) {
        this.currentIndex = -1;
        const score = this.questions.reduce((ret, q) => ret + q.score, 0);
        this.currentScore = score;
        user.quizScore.push(score);
        user.quizUpdatedAt = dayjs.utc().format();

        const token = localStorage.getItem("userToken");
        UserAPI.update(user, token);
        return;
      }
      this.currentIndex++;
    },
    openDesc() {
      this.descModal = true;
    },
    closeDesc() {
      this.descModal = false;
    },
  },
  computed: {},
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
